/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_cards_deposit_modal_description = /** @type {(inputs: {}) => string} */ () => {
	return `Usa esta información para realizar depósitos a tu tarjeta`
};

const en_cards_deposit_modal_description = /** @type {(inputs: {}) => string} */ () => {
	return `Use this information to make deposits to your card`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const cards_deposit_modal_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cards_deposit_modal_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("cards_deposit_modal_description", locale)
	if (locale === "es") return es_cards_deposit_modal_description(inputs)
	return en_cards_deposit_modal_description(inputs)
};
export { cards_deposit_modal_description as "cards.deposit_modal.description" }